import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined: loading, null: anon
  const [tenant, setTenant] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      setTenant(data.tenant);
      return data;
    } catch (e) {
      setUser(null);
      setTenant(null);
      return null;
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const setSession = (data) => {
    if (data?.token) localStorage.setItem("kintarou_token", data.token);
    setUser(data.user);
    setTenant(data.tenant || null);
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) {}
    localStorage.removeItem("kintarou_token");
    setUser(null);
    setTenant(null);
  };

  return (
    <AuthCtx.Provider value={{ user, tenant, setSession, logout, refresh }}>
      {children}
    </AuthCtx.Provider>
  );
}

export function useAuth() { return useContext(AuthCtx); }
